// 新版船运管理
export default [
  {
    path: '/cruiseProject',
    component: () => import('../pages/cruiseManage/cruiseProjectManage.vue'),
    name: 'cruiseProject',
    title: '船运项目管理',
    meta: {
      title: '船运项目管理',
    },
  },
  {
    path: '/cruiseLineManage',
    component: () => import('../pages/cruiseManage/cruiseLineManage.vue'),
    name: 'cruiseLineManage',
    title: '船运线路管理',
    meta: {
      title: '船运线路管理',
    },
  },
  {
    path: '/timeTemplateSetting',
    component: () => import('../pages/cruiseManage/timeTemplateSetting.vue'),
    name: 'timeTemplateSetting',
    title: '时间模板配置',
    meta: {
      title: '时间模板配置',
    },
  },
  {
    path: '/buyCruisePointManageNew',
    component: () =>
      import('../pages/cruiseManage/buyCruisePointManageNew.vue'),
    name: 'buyCruisePointManageNew',
    title: '新版购票点管理',
    meta: {
      title: '新版购票点管理',
    },
  },
  {
    path: '/cruiseOrderManage',
    component: () => import('../pages/cruiseManage/cruiseOrderManage.vue'),
    name: 'cruiseOrderManage',
    title: '新船运订单管理',
    meta: {
      title: '新船运订单管理',
    },
  },
  {
    path: '/cruiseCalendarNew',
    component: () => import('../pages/cruiseManage/cruiseCalendarNew.vue'),
    name: 'cruiseCalendarNew',
    title: '配置日历',
    meta: {
      title: '配置日历',
    },
  },
  {
    path: '/bussinessCruiseManage',
    component: () => import('../pages/cruiseManage/bussinessCruiseManage.vue'),
    name: 'bussinessCruiseManage',
    title: '商务包船管理',
    meta: {
      title: '商务包船管理',
    },
  },
]
